import type { ViewerPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS } from './defaults';
import type { LinkPreviewPluginViewerConfig } from './types';
import { LINK_PREVIEW_TYPE } from './types';
import { nodeViewRenderers } from './viewer/nodeViewRenderers-loadable';

export { LINK_PREVIEW_TYPE, LinkPreviewPluginViewerConfig };

export const pluginLinkPreview: ViewerPluginCreator<LinkPreviewPluginViewerConfig> = config => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINK_PREVIEW_TYPE,
    nodeViewRenderers,
  };
};
